import { Box, capitalize } from "@mui/material"
import { EuropcarPieChart, EuropcarTable } from "Pages/BusinessLogistics/Analytics/Page/@components/index"
import { REQUEST_TYPE } from "Pages/BusinessLogistics/Analytics/Page/@constants"
import React from "react"
import { AppCardTitle } from "@components"

export default function EuropcarInfoBlock({ label }) {
	
	return <Box data-tour-id={`analytics-searches-by-${label}`} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
		<AppCardTitle icon="chart-pie" title={`Searches by ${capitalize(label)}`} sx={{ alignSelf: 'flex-start' }}/>
		<Box sx={{ width: '100%' }}>
			<EuropcarPieChart requestType={`${label}-${REQUEST_TYPE.CHART}`}/>
		</Box>
		<Box sx={{ width: '100%' }}>
			<EuropcarTable requestType={`${label}-${REQUEST_TYPE.TABLE}`} label={capitalize(label)}/>
		</Box>
	</Box>
}